import React from "react";
import {
  Box,
  SelectionSet,
  SelectionSetInput,
  SelectionSetLabel,
  Typography
} from "@vp/swan";
import { Trans } from "react-i18next";
import { useTranslation } from "../../useTranslation";
interface TermsAndConditionsProps {
  accepted: boolean;
  wrappedProps?: any;
  onAcceptanceChanged: (isAccepted: boolean) => void;
  disableSelection: boolean;
  site: string;
}

export const TermsAndConditionsControl: React.FunctionComponent<TermsAndConditionsProps> = (
  props: TermsAndConditionsProps
) => {
  const { accepted, disableSelection, wrappedProps } = props;
  const [t] = useTranslation("signUp");
  const termsAndPolicyChanged = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    props.onAcceptanceChanged(event.target.checked);
  };

  const displaySelectionSet = (
    <SelectionSet
      id="termsAndPolicy"
      variant="multi-select"
      aria-required="true"
      data-testid="termsAndConditions"
    >
      <SelectionSetInput
        data-testid="acceptTermsAndConditions"
        value="agree"
        checked={accepted}
        onChange={termsAndPolicyChanged}
        role="checkbox"
        aria-checked={accepted}
        aria-labelledby="acceptTermsAndConditionsLabel"
      >
        <SelectionSetLabel id="acceptTermsAndConditionsLabel">
          <Trans i18nKey="signUp:termsAndPrivacy.pattern">
            {[
              <a
                data-testid="termsAndConditions-link"
                key="termsAndConditions"
                href={t("termsAndPrivacy.termsOfServicesLink")}
                target="_blank"
                rel="noopener noreferrer"
              >
                termsOfServices
              </a>,
              <a
                data-testid="privacyPolicy-link"
                key="privacyPolicy"
                href={t("termsAndPrivacy.privacyPolicyLink")}
                target="_blank"
                rel="noopener noreferrer"
              >
                privacyPolicy
              </a>
            ]}
          </Trans>
        </SelectionSetLabel>
      </SelectionSetInput>
    </SelectionSet>
  );

  const onlyShowAcceptNotification = (
    <>
      <Typography textAlign="left" fontSkin="footnote">
        <Trans i18nKey={"signUp:termsAndPrivacy.text"}>
          {[
            <a
              data-testid="termsAndConditions-link"
              key="termsAndConditions"
              href={t("termsAndPrivacy.termsOfServicesLink")}
              target="_blank"
              rel="noopener noreferrer"
            >
              termsOfServices
            </a>,
            <a
              data-testid="privacyPolicy-link"
              key="privacyPolicy"
              href={t("termsAndPrivacy.privacyPolicyLink")}
              target="_blank"
              rel="noopener noreferrer"
            >
              privacyPolicy
            </a>
          ]}
        </Trans>
      </Typography>
    </>
  );

  return (
    <Box {...wrappedProps}>
      {disableSelection ? onlyShowAcceptNotification : displaySelectionSet}
    </Box>
  );
};

const TermsAndConditions: React.FunctionComponent<TermsAndConditionsProps> = React.memo(
  TermsAndConditionsControl
);
export default TermsAndConditions;
